"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boundingBoxSchema = void 0;
const zod_1 = require("zod");
exports.boundingBoxSchema = zod_1.z.object({
    ulx: zod_1.z.number().describe('The x coordinate of the upper left corner of the bounding box'),
    uly: zod_1.z.number().describe('The y coordinate of the upper left corner of the bounding box'),
    lrx: zod_1.z.number().describe('The x coordinate of the lower right corner of the bounding box'),
    lry: zod_1.z.number().describe('The y coordinate of the lower right corner of the bounding box'),
});
//# sourceMappingURL=BoundingBox.js.map